import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import {ReactiveFormsModule} from "@angular/forms";
import {NgbPaginationModule, NgbAlertModule} from '@ng-bootstrap/ng-bootstrap';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HomeComponent} from './views/home/home.component';
import {LoginComponent} from './views/auth/login/login.component';
import {RegisterComponent} from './views/auth/register/register.component';
import {TokenInterceptorService} from "./services/tokenInterceptor/token-interceptor.service";
import {ApiUrlInterceptorService} from "./services/apiUrl/api-url-interceptor.service";
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {ProjectModal} from './modals/project-modal/project-modal.component';
import {DatabaseModal} from "./modals/database-modal/database-modal.component";
import {DatabasesComponent} from './parts/databases/databases.component';
import {ProjectsComponent} from './parts/projects/projects.component';
import {DashboardComponent} from './views/dashboard/dashboard.component';
import {ArtworkModal} from "./modals/artwork-modal/artwork-modal.component";
import {ArtworksComponent} from "./parts/artworks/artworks.component";
import {EditRouteComponent} from './parts/editor/edit-route/edit-route.component';
import {MediaModal} from "./modals/media-modal/media-modal.component";
import {MediaComponent} from "./parts/media/media.component";
import {StructureComponent} from "./parts/structure/structure.component";
import {EditStructureComponent} from './parts/editor/edit-structure/edit-structure.component';
import {ImageListComponent} from "./parts/image-list/image-list.component";
import {CategoriesComponent} from './parts/categories/categories.component';
import {GroupsComponent} from './parts/groups/groups.component';
import {EditCategoryComponent} from './parts/editor/edit-category/edit-category.component';
import {EditGroupComponent} from './parts/editor/edit-group/edit-group.component';
import {CategoryModal} from './modals/category-modal/category-modal.component';
import {GroupModal} from './modals/group-modal/group-modal.component';
import {CollapsableComponent} from './parts/collapsable/collapsable.component';
import {MediaSelectionModal} from './modals/media-selection-modal/media-selection-modal.component';
import {MediaSelectionComponent } from './parts/media-selection/media-selection.component';
import {ConfirmModal} from './modals/confirm-modal/confirm-modal.component';
import {SuccessModal} from './modals/success-modal/success-modal.component';
import {ErrorModal} from './modals/error-modal/error-modal.component';
import {NavComponent} from './parts/nav/nav.component';
import {FooterComponent} from './parts/footer/footer.component';
import {ArtworkCategoryModal} from './modals/artwork-category-modal/artwork-category-modal.component';
import {ToastrModule} from "ngx-toastr";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {CommonModule} from "@angular/common";
import { MediaMultipleSelectionComponent } from './parts/media-multiple-selection/media-multiple-selection.component';
import { QrGeneratorComponent } from './parts/qr-generator/qr-generator.component';
import {QRCodeModule} from "angularx-qrcode";
import { LoadingComponent } from './parts/loading/loading.component';
import { RecoveryComponent } from './views/auth/recovery/recovery.component';
import {PasswordRecoveryModal} from "./modals/password-recovery-modal/password-recovery-modal.component";
import {RoutesComponent} from "./parts/routes/routes.component";
import {RouteModal} from "./modals/route-modal/route-modal.component";
import {EditArtworkComponent} from "./parts/editor/edit-artwork/edit-artwork.component";
import {RouteArtworkModal} from "./modals/route-artwork-modal/route-artwork-modal.component";

@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        LoginComponent,
        RegisterComponent,
        ProjectModal,
        MediaModal,
        DatabaseModal,
        ImageListComponent,
        StructureComponent,
        MediaComponent,
        DatabasesComponent,
        ProjectsComponent,
        DashboardComponent,
        ArtworksComponent,
        ArtworkModal,
        EditRouteComponent,
        EditStructureComponent,
        CategoriesComponent,
        GroupsComponent,
        EditCategoryComponent,
        EditGroupComponent,
        CategoryModal,
        GroupModal,
        CollapsableComponent,
        MediaSelectionModal,
        MediaSelectionComponent,
        ConfirmModal,
        SuccessModal,
        ErrorModal,
        NavComponent,
        FooterComponent,
        ArtworkCategoryModal,
        MediaMultipleSelectionComponent,
        QrGeneratorComponent,
        LoadingComponent,
        RecoveryComponent,
        PasswordRecoveryModal,
        RoutesComponent,
        RouteModal,
        EditArtworkComponent,
        RouteArtworkModal,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        ReactiveFormsModule,
        NgbPaginationModule,
        NgbAlertModule,
        NgbModule.forRoot(),
        CommonModule,
        BrowserAnimationsModule,
        QRCodeModule,
        ToastrModule.forRoot({
            timeOut: 2500,
            positionClass: 'toast-bottom-center',
            preventDuplicates: true
        })
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ApiUrlInterceptorService,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptorService,
            multi: true
        }
    ],
    bootstrap: [AppComponent],
    entryComponents: [
        MediaModal,
        DatabaseModal,
        ProjectModal,
        ArtworkModal,
        CategoryModal,
        GroupModal,
        MediaSelectionModal,
        ErrorModal,
        SuccessModal,
        ConfirmModal,
        ArtworkCategoryModal,
        PasswordRecoveryModal,
        RouteModal,
        RouteArtworkModal,
    ]
})

export class AppModule {}
